export default "__VITE_ASSET__B23NGumk__"